import { PointHistory } from "shared/models/index";
import clients from "shared/repositories/HttpClient";
import { PointHistoriesResponse } from "shared/types";

const PointHistoriesRepository = {
  index: async (url: string): Promise<PointHistoriesResponse> => {
    const res = await clients.miror.get(url);
    const pointHistories = res.data?.pointHistories?.map(
      (pointHistory: any) => new PointHistory(pointHistory)
    );
    return { pointHistories, meta: res.data.meta };
  },
};

export default PointHistoriesRepository;
